/* eslint-disable import/prefer-default-export */
import { roadmapActions } from '../rootTypes';

export const setActivePhase = phase => ({
  type: roadmapActions.setActiveField,
  payload: phase,
});
export const getRoadmapTeasers = () => ({ type: roadmapActions.fetchContentRequest });
